import {
  AdminCustomProviderSelect,
  AdminCustomVDriveProviderSelect,
  Button,
  Div,
  ErrorToast,
  ModalPortal,
  Provider,
  VDriveProvider,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useState } from 'react';

export const AddAssignmentProvider = ({
  isOpen,
  setIsOpen,
  addFunction,
  header,
  orderProvider = false,
  alreadyAddedProviders,
  availableProviders,
  bannedProviders = [],
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  addFunction: (provider: string | Provider | VDriveProvider) => void;
  header: string;
  orderProvider?: boolean;
  alreadyAddedProviders?: (string | Provider | VDriveProvider)[];
  availableProviders?: VDriveProvider[];
  bannedProviders?: VDriveProvider[];
}) => {
  const [provider, setProvider] = useState<
    string | Provider | VDriveProvider | null
  >('');

  function toggleModal() {
    setIsOpen((prev) => !prev);
    clearState();
  }

  const clearState = () => {
    setProvider('');
  };

  const handleSubmit = () => {
    if (!provider) return ErrorToast('Please Select Provider.');
    addFunction(provider);
    toggleModal();
  };

  return (
    <ModalPortal
      header={header}
      isOpen={isOpen}
      closeModal={toggleModal}
      overflow="visible"
      zIndex={131}
    >
      <Div $flex $column $gap="24px">
        {orderProvider ? (
          <AdminCustomProviderSelect
            value={provider}
            onChange={(value) => {
              setProvider(value as string);
            }}
            label="Order Provider"
            $textCenter
            $shadowDesign={false}
            disabledProviders={alreadyAddedProviders || []}
            emptyPlaceholder="All providers have been added"
          />
        ) : (
          <AdminCustomVDriveProviderSelect
            value={provider}
            onChange={(value) => {
              setProvider(value as VDriveProvider);
            }}
            label="Delivery Provider"
            $textCenter
            $shadowDesign={false}
            disabledProviders={[
              ...(alreadyAddedProviders || []),
              ...(bannedProviders || []),
            ]}
            emptyPlaceholder="All providers have been added"
            providerArray={availableProviders}
          />
        )}
      </Div>
      <Button $w="100%" $mt="32" $selected onClick={handleSubmit}>
        Confirm
      </Button>
      <Button $w="100%" $mt="16" $selected $gray onClick={toggleModal}>
        Cancel
      </Button>
    </ModalPortal>
  );
};
